import GlobalStyles from "./GlobalStyles";
import Landing from "./components/landing";
import Introduction from "./components/introduction";
import ReportingProblem from "./components/reportingProblem";
import Mirroring from "./components/mirroring";
import Classification from "./components/classification";
import Conclusion from "./components/conclusion";

// Main page with all sections
function MainPage() {
  return (
    <div className="trade-methodology-page">
      <GlobalStyles />
      <div id="landing">
        <Landing />
      </div>
      <div id="introduction">
        <Introduction />
      </div>
      <div id="reporting-problem">
        <ReportingProblem />
      </div>
      <div id="mirroring">
        <Mirroring />
      </div>
      <div id="classification">
        <Classification />
      </div>
      <div id="conclusion">
        <Conclusion />
      </div>
    </div>
  );
}

export default MainPage;
